import { NonActiveSubscription } from "../Account.styled";

const SubscriptionUnknown = () => {
  return (
    <NonActiveSubscription>
      <p>
        Your subscription can not be found.
        <br />
        Please contact the Member Experience Team for assistance.
      </p>
    </NonActiveSubscription>
  );
};

export default SubscriptionUnknown;
